/* ObiHub OS — izole kabuk çerçevesi. Üretim router/layout bağlantısı yoktur. */
import React from "react";
import "./shell.css";

export function OsShellFrame({ brand, workspace, breadcrumb, children, dock, modalLayer = null, interactionLocked = false, className = "" }) {
  if (!brand) throw new Error("OsShellFrame: brand alanı zorunludur");
  if (Boolean(modalLayer) !== Boolean(interactionLocked)) throw new Error("OsShellFrame: modalLayer ve interactionLocked birlikte kullanılmalıdır");
  return (
    <div className={`os-shell ${className}`.trim()} data-os-root="" data-locked={interactionLocked ? "true" : "false"}>
      <header className="os-shell__top" aria-hidden={interactionLocked ? "true" : undefined} inert={interactionLocked ? true : undefined}>
        <div className="os-shell__brand">{brand}</div>
        <div className="os-shell__workspace">{workspace}</div>
      </header>
      {breadcrumb ? <div className="os-shell__breadcrumb" aria-hidden={interactionLocked ? "true" : undefined} inert={interactionLocked ? true : undefined}>{breadcrumb}</div> : null}
      <main className="os-shell__content" aria-hidden={interactionLocked ? "true" : undefined} inert={interactionLocked ? true : undefined}>{children}</main>
      <div className="os-shell__dock" aria-hidden={interactionLocked ? "true" : undefined} inert={interactionLocked ? true : undefined}>{dock}</div>
      {modalLayer ? <div className="os-shell__modal-layer">{modalLayer}</div> : null}
    </div>
  );
}
